import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "../../style/custommillingHubdashboard.css";
import "../../style/customresponsivefile.css";
import "../../style/Cancelorder.css";
import "../../style/designer-milling-responsive.css";

import SearchBox from "../../Interfaces/SearchBoxProps";
import SortFilter from "../CentralHub/Designer/SortFilter";
import { CompleteOrderRow } from "../CentralHub/Admin/Interfaces/CompleteOrderRow";
import { apiAxios } from "../../utils/apiAxios";


const MillingCompleteOrder: React.FC = () => {

  const [orders, setOrders] = useState<CompleteOrderRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedOrder, setSelectedOrder] = useState<CompleteOrderRow | null>(null);
  const [showModal, setShowModal] = useState(false);

  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage] = useState(10);

  // 🔥 API CALL
  const fetchOrders = async (pageNumber = 1, search = "") => {
    try {
      setLoading(true);

      const res = await apiAxios.get("/MillingHub/completed-orders", {
        params: {
          search,
          pageNumber,
          pageSize: perPage
        }
      });

      const json = res.data;

      if (json.isSuccess) {

        const apiData = json.dataOne.data;
        console.log(apiData,"milling data");
        const mapped = apiData.map((item: any) => {

          return {
            orderId: item.orderID ?? "-",
            clinicName: item.clinicName ?? "-",
            phone: item.phone ?? "-",
            orderTypeName: item.orderTypeName ?? "-",

            orderDate: item.orderDate
              ? new Date(item.orderDate).toLocaleString("en-GB")
              : "-",

            millingHub: item.millingHub ?? "-",

            designerName: item.designerName ?? "-",

            deliveryPartner: item.deliveryPartner ?? "-",

            deliveryDate: item.deliveryDate
              ? new Date(item.deliveryDate).toLocaleString("en-GB")
              : "-",

            payment: item.paymentStatus ?? "-",

            paymentType: item.paymentType ?? "-",

            amount: item.amount ?? "-",

            status: item.status ?? "-"
          };
        });

        setOrders(mapped);

        setTotalRows(json.dataOne.totalRecords);

      } else {
        toast.error("No data found");
      }

    } catch (error) {
      console.error("Fetch Orders Error =>", error);
      toast.error("Failed to load completed orders");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 PAGE CHANGE
  useEffect(() => {
    fetchOrders(page, searchText);
  }, [page]);

  // 🔥 SEARCH (Debounce)
  useEffect(() => {
    const delay = setTimeout(() => {
      setPage(1);
      fetchOrders(1, searchText);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchText]);

  // 🔥 TABLE COLUMNS
  const columns = [
    {
      name: "OrderID",
      selector: (row: CompleteOrderRow) => row.orderId,
      sortable: true
    },
    {
      name: "Order Type",
      selector: (row: CompleteOrderRow) => row.orderTypeName,
      sortable: true
    },

    {
      name: "Clinic / Phone",
      minWidth: "180px",
      cell: (row: CompleteOrderRow) => (
        <div>
          <div className="fw-semibold">{row.clinicName}</div>
          <div className="text-muted">{row.phone}</div>
        </div>
      )
    },

    {
      name: "Order Date",
      selector: (row: CompleteOrderRow) => row.orderDate,
      minWidth: "170px"
    },


    {
      name: "Status",
      width: "180px",
      cell: (row: CompleteOrderRow) => (
        <span className="badge bg-success">
          {row.status}
        </span>
      )

    },

    {
      name: "View",
      cell: (row: CompleteOrderRow) => (
        <button
          className="action-btn edit"
          onClick={() => {
            setSelectedOrder(row);
            setShowModal(true);
          }}
        >
          <i className="bi bi-eye"></i>
        </button>
      )
    }

  ];

  return (

    <div className="container-fluid mt-4">


      <h4 className="mb-4">Completed Orders</h4>


      <div className="premium-card mt-4">

        <div className="d-lg-flex d-md-block justify-content-lg-between mb-3">

          <SearchBox
            value={searchText}
            onChange={setSearchText}
          />

          <SortFilter />

        </div>

        <DataTable
          columns={columns}
          data={orders}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={(page) => setPage(page)}
          highlightOnHover
          striped
          responsive
          progressPending={loading}
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />

      </div>

      {/* 🔥 MODAL */}

      {showModal && selectedOrder && (

        <div className="modal fade show d-block modal-bg d-flex align-items-center justify-content-center">

          <div
            className="modal-dialog m-0"
            style={{ maxWidth: "550px", width: "100%" }}
          >

            <div className="modal-content">

              <div className="modal-header premium-modal-header">

                {/* <h5>Order Details</h5> */}
                <h5 className="modal-title"> Order Details: {selectedOrder?.orderId || "--"}</h5>

                <button
                  className="custom-close-btn btn-close "
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x customcross"></i>
                </button>

              </div>

              <div className="modal-body pt-0 mt-0">


                <ul className="list-unstyled order-details-list mb-0">

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Designer</span>
                    <span className="value">{selectedOrder.designerName}</span>
                  </li>

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Delivery Partner</span>
                    <span className="value">{selectedOrder.deliveryPartner}</span>
                  </li>

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Delivered Date</span>
                    <span className="value">{selectedOrder.deliveryDate}</span>
                  </li>

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Order Type</span>
                    <span className="value">{selectedOrder.orderTypeName}</span>
                  </li>

                  {/* <li className="order-item d-flex justify-content-between align-items-center py-2">
              <span className="label">Payment Type</span>
              <span className="value">{selectedOrder.paymentType}</span>
            </li> */}

                </ul>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default MillingCompleteOrder;